import React, { useEffect, useRef, useState } from 'react'
import './view-rewards-modal.styles.scss'

import Modal from '@/components/modal/modal.component'
import { useSelector } from 'react-redux'
import { format, set } from 'date-fns'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { StackedCarousel } from 'react-card-stack-carousel'
import HiddenText from '@/components/SHARED/hidden-text/hidden-text.component'
import { act } from 'react'

const ViewRewardsModal = ({ 
    playerData,
    isOpen, 
    onClose, 
    activity, 
    modalHeadText 
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ preview, setPreview ] = useState(false);
    const [ gifUrl, setGifUrl ] = useState(null);
    const [ gifs ] = useState({
        'reward': '/images/icons/treasure.gif',
        'achievement': '/images/icons/achievement_gif_half.gif',
        'prizepack': '/images/icons/prizepack_gif_short.gif'
    })
    const containerHeight = 300;
    const timeoutRef = useRef();

    useEffect(() => {

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    }, [])

    useEffect(() => {
        if (!isOpen || !playerData || !gifs) return;
        if (playerData.newStuff.includes(activity.id)) {
            setPreview(true);
            // timeoutRef.current = setTimeout(() => {
                setGifUrl(gifs[activity.display]);
                // const el = document.getElementById('gif-container')
                // // if (el) {
                // console.log(el);
                //     el.src = gifs[activity.display];
            // }, 500);
                    // }
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                setGifUrl(null);
                // if (el) {
                const el = document.getElementById('gif-container')
                    el.src = null;
                // } 
                setPreview(false);
            }, 2000);
        }
    }, [isOpen, playerData, gifs])

    return (
        <div className='view-rewards-modal'>
            <Modal show={isOpen} cancel={onClose} cls={'narrow'} closeButton={true} text={modalHeadText} >
                {
                    (preview)
                    ?
                    <div className='modal-children'>
                        <ImageContainer 
                            id='gif-container'
                            className='reward-gif'
                            src={gifUrl}
                        />
                    </div>
                    :
                    (
                        !preview &&
                        activity &&
                        activity.display === 'prizepack'
                    )
                    ?
                    <div className='slider'>
                        <StackedCarousel height={containerHeight}>
                        {
                            (
                                activity.data &&
                                Object.values(activity.data).length > 0
                            ) &&
                            Object.values(activity.data).map((a, index) => (
                                <div key={a.id + index} className='g-card'>
                                    <div className='slider-image-div'>
                                        <ImageContainer src={a.icon} className='slider-image' />
                                        {
                                            (a.quantity > 0) &&
                                            <div className='count-flag'>
                                                x {a.quantity}
                                            </div>
                                        }
                                    </div>
                                    <div className='g-space-0-5'></div>
                                    <div className='center-col'>
                                        <p>Prize {index + 1}</p>
                                        <h3>{a.title.substring(a.title.indexOf(':') + 2, a.title.length +1)}</h3>
                                    </div>
                                </div>
                            ))
                        }
                        </StackedCarousel>
                    </div>
                    :
                    (!preview && activity)
                    ?
                    <div  className='modal-children'>
                        <div className='view-rewards-head g-card'>
                            <div className={`view-rewards-title ${screenSize}`}>
                                <ImageContainer src={activity.icon} alt='clickable treasure icon' className='view-rewards-big-icon' />
                                <div className='activity-title'>{activity.title}</div>
                            </div>
                            <div className='view-rewards-head-text'>
                                
                                <div>
                                    <span className='desc'>
                                        {activity.event}
                                    </span>
                                    <br />
                                    {
                                        (activity.type === 'secretCode') && 
                                        <HiddenText 
                                            text={activity.title} 
                                            hidden={true} /> 
                                    }
                                    
                                    <div className='desc'>
                                        Earned {format(new Date(activity.ts), 'Pp')}
                                    </div>
                                {
                                    (activity.event === 'Secret Code Found') &&
                                    <>
                                        <b>{activity.info}</b><br />
                                    </>
                                }
                                {
                                    (activity.comments) && 
                                    <>
                                        <br />Evaluator comments:<br /><b>"{activity.comments}"</b>
                                    </>
                                }
                                </div>
                            </div>
                        </div>
                        {
                            (activity.data && Object.values(activity.data).length > 0) &&
                            <div className='earnings-box'>    
                                <div className="g-space-1"></div>
                                
                                <h2>Rewards</h2>
                                
                                {
                                    Object.values(activity.data)
                                    .map((earning, index) => (
                                        <div key={index} className={`g-card ${screenSize}`}>
                                            <ImageContainer src={earning.icon} alt='reward icon' className='earning-icon' />
                                            <div className='earning-text'>
                                                {
                                                    (earning.title.indexOf(':') > -1)
                                                    ?
                                                    <><b>{earning.title.split(': ')[1]}</b><br /><span>({earning.title.split(': ')[0]})</span></>
                                                    :
                                                    <b>{earning.title}</b>
                                                }
                                            </div>
                                            {
                                                (earning.quantity) &&
                                                <div>x{earning.quantity}</div>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        }
                    </div>
                    : ''
                }
            </Modal>
        </div>
    )
}

export default ViewRewardsModal;